import * as BABYLON from "babylonjs";

function applyLighting(scene, hdrRotationY = 2) {
    // Garder l'HDRI pour les réflexions mais avec une intensité réduite
    const envTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(
        "assets/industrial_sunset_02_puresky_2k.env",
        scene
    );

    envTexture.level = 1;
    scene.environmentTexture = envTexture;
    scene.environmentTexture.rotationY = hdrRotationY;

    scene.environmentIntensity = 0.5;

    // Rendre la couleur de fond transparente
    scene.clearColor = new BABYLON.Color4(0, 0, 0, 0); 

    // Set fog mode, color, and density
    scene.fogMode = BABYLON.Scene.FOGMODE_EXP;
    scene.fogColor = new BABYLON.Color3.FromHexString("#33334D");
    scene.fogDensity = 0.04;

    // Image processing pour la qualité visuelle
    if (!scene.imageProcessingConfiguration) {
        scene.imageProcessingConfiguration = new BABYLON.ImageProcessingConfiguration();
    }

    scene.imageProcessingConfiguration.contrast = 1.2;
    scene.imageProcessingConfiguration.exposure = 1.2;
    scene.imageProcessingConfiguration.toneMappingEnabled = true;
}

export { applyLighting };